module.exports = __webpack_public_path__ + "static/media/iconCanvas06.9a1259e0.svg";